import PrimerErrorPropsIos from "../../../../content/sdk/ios/2.x.x/_common/_props/PrimerErrorPropsIos.mdx";
import SdkConfigurationErrors from '/content/sdk/common/2.x.x/sdkConfigurationErrors.mdx';
import ConnectivityErrors from '/content/sdk/common/2.x.x/connectivityErrors.mdx';
import HttpErrors from '/content/sdk/common/2.x.x/httpErrors.mdx';
import PaymentErrors from '/content/sdk/common/2.x.x/paymentErrors.mdx';
import HeadlessIoSErrors from '/content/sdk/common/2.x.x/headlessiOSErrors.mdx';
import ApplePayErrors from '/content/sdk/common/2.x.x/applePayErrors.mdx';
import KlarnaErrors from '/content/sdk/common/2.x.x/klarnaErrors.mdx';
import IPayErrors from '/content/sdk/common/2.x.x/iPayErrors.mdx';
import NolPayErrors from '/content/sdk/common/2.x.x/nolPayErrors.mdx';
import SessionCreateErrors from '/content/sdk/common/2.x.x/sessionCreateErrors.mdx';
import GeneralErrors from '/content/sdk/common/2.x.x/generalErrors.mdx';
import * as React from 'react';
export default {
  PrimerErrorPropsIos,
  SdkConfigurationErrors,
  ConnectivityErrors,
  HttpErrors,
  PaymentErrors,
  HeadlessIoSErrors,
  ApplePayErrors,
  KlarnaErrors,
  IPayErrors,
  NolPayErrors,
  SessionCreateErrors,
  GeneralErrors,
  React
};